module.exports = __webpack_public_path__ + "static/media/logicpro-logo.c7248d4b.png";


//////////////////
// WEBPACK FOOTER
// ./src/Assets/v2/internships/logicpro-logo.png
// module id = 881
// module chunks = 1